import React, { useState } from 'react'
import DashboardPage from './pages/DashboardPage'
import FeedPage from './pages/FeedPage'
import ActionsPage from './pages/ActionsPage'
import ContactsPage from './pages/ContactsPage'
import ChatPage from './pages/ChatPage'
import ProceduresPage from './pages/ProceduresPage'
import DocumentsPage from './pages/DocumentsPage'
import UsagePage from './pages/UsagePage'

const TABS = [
  { id: 'chat', label: 'Ask' },
  { id: 'dashboard', label: 'HQ' },
  { id: 'feed', label: 'Feed' },
  { id: 'actions', label: 'Actions' },
  { id: 'contacts', label: 'People' },
  { id: 'documents', label: 'Docs' },
  { id: 'procedures', label: 'Playbooks' },
  { id: 'usage', label: 'Usage' },
]

const VALID_TABS = new Set(TABS.map(t => t.id))

function getSavedTab(): string {
  try {
    const saved = localStorage.getItem('hq_active_tab')
    return saved && VALID_TABS.has(saved) ? saved : 'chat'
  } catch {
    return 'chat'
  }
}

export default function App() {
  const [tab, setTab] = useState(getSavedTab)

  function switchTab(id: string) {
    setTab(id)
    try { localStorage.setItem('hq_active_tab', id) } catch {}
  }

  return (
    <div className="app">
      <header className="app-header">
        <h1>AtlasHQ</h1>
      </header>

      <nav className="nav-tabs">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={`nav-tab ${tab === t.id ? 'active' : ''}`}
            onClick={() => switchTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      <main className={`app-content${tab !== 'chat' ? ' app-content--with-inspector' : ''}`}>
        {tab === 'chat' && <ChatPage />}
        {tab === 'dashboard' && <DashboardPage />}
        {tab === 'feed' && <FeedPage />}
        {tab === 'actions' && <ActionsPage />}
        {tab === 'contacts' && <ContactsPage />}
        {tab === 'documents' && <DocumentsPage />}
        {tab === 'procedures' && <ProceduresPage />}
        {tab === 'usage' && <UsagePage />}
      </main>
    </div>
  )
}
